// extracted by mini-css-extract-plugin
export default {"instrumentNameContainer":"instrumentNameContainer-jHHdv","instrumentImage":"instrumentImage-Sdl8S","instrumentName":"instrumentName-iOeGt","instrumentType":"instrumentType-kFJjz"};